import React from 'react';
import { isClientEnv } from '@app/src/utils/validations';
import {
  Wrapper,
  Title,
  Message,
  Image,
  Description,
  Detail,
  ButtonExit,
  ButtonWrapper
} from './styled';

const isClient = isClientEnv(); 

interface Props {
  imgSrc?: string;
  title: string;
  message: string;
  buttonText: string;
  details?: {
    order?: number;
    date?: string;
    price?: number;
    cip?: number;
  };
  theme?: string;
  redirect?: string;
}

export const MessageConfirm: React.FC<Props> = ({
  imgSrc,
  title,
  message,
  buttonText,
  details,
  theme,
  redirect
}) => {

  const handleClick = () => {
    if (isClient) {
      sessionStorage.removeItem('print');
      (window as any).location.href = redirect;
    }
  };

  const handleClickExit = () => {
    if (isClient) {
      sessionStorage.removeItem('print');
      (window as any).location.href = '/#inicio';
    }
  };

return(
  <Wrapper>
    <Image src={imgSrc} />
    <Title>{title}</Title>
    <Message>{message}</Message>
    { details &&
      <Description>
        {details.cip && <Detail>Código de pago CIP: {details.cip}</Detail>}
        <Detail>Número de orden: {details.order}</Detail>
        <Detail>Fecha{details.cip && ' de expiración'}: {details.date}</Detail>
        <Detail>Total: S/ {details.price}</Detail>
      </Description>
    }
    <ButtonWrapper
      text={buttonText}
      background={theme}
      color="#fff"
      width={184}
      handleClick={handleClick}
    />
    <ButtonExit
      text="Salir"
      background="#fff"
      color={theme}
      width={184}
      handleClick={handleClickExit}
    />
  </Wrapper>
)}
